export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/outdoor_lifestyle.64b08f2.svg";